import ImageUpload from "../ImageUpload";
import { TEXT_DEFAULTS, MONTH_PHOTO_DEFAULTS } from "../../lib/siteTexts";

const MONTH_NAMES = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];
const bc = { borderColor: "var(--wp-border)" };

function Field({ s, upd, k, label, hint, rows = 0 }) {
  const value = s[k] === undefined ? TEXT_DEFAULTS[k] || "" : s[k];
  const ph = TEXT_DEFAULTS[k] || "";
  return (
    <div>
      <label className="overline">{label}</label>
      {rows ? (
        <textarea value={value} placeholder={ph} onChange={(e) => upd(k, e.target.value)} className="w-full mt-1 px-3 py-2 rounded-lg border text-sm" style={{ ...bc, minHeight: rows * 24 }} data-testid={`setting-${k}`} />
      ) : (
        <input value={value} placeholder={ph} onChange={(e) => upd(k, e.target.value)} className="w-full mt-1 px-3 py-2 rounded-lg border text-sm" style={bc} data-testid={`setting-${k}`} />
      )}
      <p className="text-xs opacity-60 mt-1">{hint ? `${hint} ` : ""}Leer lassen = Standardtext.</p>
    </div>
  );
}

function Card({ title, children }) {
  return (
    <div className="plant-card p-5 space-y-3">
      <div className="overline border-b pb-2" style={bc}>{title}</div>
      {children}
    </div>
  );
}

export function TourTextsSettings({ s, upd }) {
  const f = (k, label, hint, rows) => <Field s={s} upd={upd} k={k} label={label} hint={hint} rows={rows} />;
  return (
    <Card title="🌿 Touren – Texte auf Tour-Seite & Buchung">
      {f("tour_badges", "Badges auf jeder Tour-Karte", "Je Zeile ein Badge – das erste wird waldgrün hervorgehoben.", 4)}
      {f("tour_good_to_know_title", "Überschrift Infoblock")}
      {f("tour_good_to_know", "Infoblock-Zeilen", "Je Zeile „Bezeichnung: Text“ – z. B. „Kosten: keine – alle Touren sind kostenlos.“", 10)}
      {f("tour_herb_note", "Kräuter-Hinweis (unter der Tour-Beschreibung)", "", 2)}
      {f("tour_no_dates_text", "Text, wenn eine Tour noch keine Termine hat", "", 2)}
      {f("tour_meeting_hint", "Hinweis, wenn ein Termin noch keinen Treffpunkt zeigt", "", 2)}
      <div>
        <label className="overline">Uhrzeit der Erinnerungs-Mail (2 Tage vor dem Termin)</label>
        <input type="time" value={s.tour_reminder_time || "09:30"} onChange={(e) => upd("tour_reminder_time", e.target.value)} className="mt-1 px-3 py-2 rounded-lg border text-sm" style={bc} data-testid="setting-tour_reminder_time" />
      </div>
    </Card>
  );
}

export function DontDoSettings({ s, upd }) {
  const f = (k, label, hint, rows) => <Field s={s} upd={upd} k={k} label={label} hint={hint} rows={rows} />;
  const image = (s.tour_dont_do_image || "").trim() || TEXT_DEFAULTS.tour_dont_do_image;
  return (
    <Card title="🤝 Block „Was wir nicht tun“ (Startseite & Touren)">
      <div className="grid sm:grid-cols-2 gap-3">
        {f("tour_dont_do_overline", "Kleine Überschrift")}
        {f("tour_dont_do_title", "Überschrift")}
      </div>
      {f("tour_dont_do_items", "Punkte", "Je Zeile ein Punkt – die Nummern 01, 02, 03 … kommen automatisch.", 4)}
      {f("tour_dont_do_closing", "Schlusssatz")}
      <div>
        <label className="overline">Foto</label>
        <div className="flex items-start gap-3 mt-1">
          <ImageUpload value={image} onChange={(v) => upd("tour_dont_do_image", v)} endpoint="/admin/uploads" testId="setting-img-tour_dont_do_image" />
          <input value={image} onChange={(e) => upd("tour_dont_do_image", e.target.value)} className="flex-1 px-3 py-2 rounded-lg border text-xs" style={bc} />
        </div>
      </div>
      {f("tour_dont_do_image_alt", "Bildbeschreibung (Alt-Text)")}
    </Card>
  );
}

export function CalendarPhotosSettings({ s, upd }) {
  const own = Array.from({ length: 12 }, (_, i) => (s.calendar_month_photos || [])[i] || {});
  const list = own.map((o, i) => ({ url: o.url || MONTH_PHOTO_DEFAULTS[i].url, alt: o.alt || MONTH_PHOTO_DEFAULTS[i].alt, mood: o.mood || MONTH_PHOTO_DEFAULTS[i].mood }));
  // Only store real changes; unchanged values stay empty so website defaults keep applying.
  const set = (i, key, v) => upd("calendar_month_photos", own.map((o, j) => (j === i ? { ...o, [key]: v === MONTH_PHOTO_DEFAULTS[i][key] ? "" : v } : o)));
  return (
    <Card title="📅 Saisonkalender – Monatsbilder">
      <div className="grid md:grid-cols-2 gap-4">
        {list.map((m, i) => (
          <div key={i} className="p-3 rounded-xl border bg-white space-y-2" style={bc} data-testid={`setting-month-photo-${i + 1}`}>
            <div className="font-medium text-sm">{MONTH_NAMES[i]}</div>
            <div className="flex items-start gap-3">
              <ImageUpload value={m.url} onChange={(v) => set(i, "url", v)} endpoint="/admin/uploads" testId={`setting-month-img-${i + 1}`} />
              <div className="flex-1 space-y-2">
                <input value={m.mood} onChange={(e) => set(i, "mood", e.target.value)} placeholder="Stimmungszeile" className="w-full px-2 py-1.5 rounded-lg border text-xs" style={bc} data-testid={`setting-month-mood-${i + 1}`} />
                <input value={m.alt} onChange={(e) => set(i, "alt", e.target.value)} placeholder="Bildbeschreibung" className="w-full px-2 py-1.5 rounded-lg border text-xs" style={bc} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}

export function ContactTextsSettings({ s, upd }) {
  const f = (k, label, hint, rows) => <Field s={s} upd={upd} k={k} label={label} hint={hint} rows={rows} />;
  return (
    <Card title="✉️ Kontaktformular & Kontaktzeilen">
      {f("contact_topics", "Auswahl „Worum geht es?“", "Je Zeile ein Thema – das gewählte Thema steht im Betreff der E-Mail an euch.", 4)}
      {f("contact_privacy_text", "Datenschutz-Checkbox", "Das Wort „Datenschutzerklärung“ wird automatisch verlinkt.", 3)}
      {f("contact_success_text", "Bestätigung nach dem Senden", "", 2)}
      {f("contact_direct_text", "Text vor der E-Mail-Adresse (Kontaktseite)")}
      <div className="grid sm:grid-cols-3 gap-3">
        {f("footer_tours_email", "E-Mail für Touren (Footer & Kontakt)")}
        {f("footer_more_info_label", "„Mehr Infos“ – Linktext")}
        {f("footer_more_info_url", "„Mehr Infos“ – Link")}
      </div>
    </Card>
  );
}
